// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"Contact_marginBottom__CXxJX"};